import GiftCardLink from './GiftCardLink';
import enhance from './GiftCardLinkContainer';

export default enhance(GiftCardLink);



// WEBPACK FOOTER //
// ./src/app/giftCard/GiftCardLink/index.js